import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import {
  BRANCH_FIELD_CONFIG,
  BranchFormErrors,
  BranchFormField,
  BranchFormValues,
  CREATE_FIELDS,
  isOptionalField,
} from "./branchForm";
import { BranchFieldChangeEvent } from "./useBranchForm";

const LOCKED_FIELD_HINT = "แก้ไม่ได้หลังสร้าง";

interface BranchFormFieldsProps {
  values: BranchFormValues;
  errors: BranchFormErrors;
  /** Shown but not editable — NN and AA once the branch exists. */
  lockedFields?: readonly BranchFormField[];
  onFieldChange: (event: BranchFieldChangeEvent) => void;
}

const helperTextOf = (error: string | undefined, isLocked: boolean) =>
  error ?? (isLocked ? LOCKED_FIELD_HINT : undefined);

/** Every branch field in one grid, used by both the create dialog and the edit form. */
export default function BranchFormFields({
  values,
  errors,
  lockedFields = [],
  onFieldChange,
}: BranchFormFieldsProps) {
  return (
    <Grid container spacing={2}>
      {CREATE_FIELDS.map((field) => {
        const config = BRANCH_FIELD_CONFIG[field];
        const isLocked = lockedFields.includes(field);
        return (
          <Grid key={field} size={{ xs: 12, sm: config.gridSize }}>
            <TextField
              name={field}
              label={config.label}
              value={values[field]}
              onChange={onFieldChange}
              placeholder={config.placeholder}
              required={!isLocked && !isOptionalField(field)}
              disabled={isLocked}
              error={Boolean(errors[field])}
              helperText={helperTextOf(errors[field], isLocked)}
              size="small"
              fullWidth
              slotProps={{ htmlInput: { maxLength: config.maxLength } }}
            />
          </Grid>
        );
      })}
    </Grid>
  );
}
